import { useEffect, useRef } from "react";
import { VIDEOS } from "@/data/site";

export const JayWorking = () => {
  return (
    <section id="watch" className="section bg-[#121212] border-t border-[#27272A]">
      <div className="container-x">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-16">
          <div>
            <div className="text-xs uppercase tracking-[0.4em] text-accent mb-4">/ 03 In Action</div>
            <h2 className="font-display text-5xl sm:text-7xl text-white leading-none" data-testid="watch-title">
              WATCH JAY
              <br />
              WORK.
            </h2>
          </div>
          <p className="text-dim max-w-md text-base">
            Clippers in motion. Lines being drawn. Fades blending down to the skin.
            Press play — or just let them run.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {VIDEOS.map((v, i) => (
            <VideoCard key={v.url} video={v} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

const VideoCard = ({ video, index }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.play().catch(() => {});
        } else {
          el.pause();
        }
      },
      { threshold: 0.4 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div
      className="relative overflow-hidden rounded-md bg-black border border-[#27272A] group aspect-[9/16]"
      data-testid={`video-card-${index}`}
    >
      <video
        ref={ref}
        src={video.url}
        className="w-full h-full object-cover"
        muted
        loop
        playsInline
        preload="metadata"
        controls
        data-testid={`video-player-${index}`}
      />
      <div className="absolute top-4 left-4 bg-black/60 backdrop-blur px-3 py-1.5 rounded text-[10px] uppercase tracking-[0.3em] text-white border border-white/10 pointer-events-none">
        {video.label}
      </div>
    </div>
  );
};
